import { FC } from 'react';

import { KeyTextObj } from '~src/interfaces/translation.interface';
import HoverImageInfo from '~src/shared/tooltips/HoverImageInfo';

import * as SC from './headers.sc';

interface Props {
  title: KeyTextObj;
  tooltipText: KeyTextObj;
  pictureText: KeyTextObj;
  imageUrl: string;
}

const SectionHeader: FC<Props> = ({ title, tooltipText, imageUrl, pictureText }) => (
  <SC.HeaderContainer>
    <span data-translation={title.key}>{title.txt}</span>
    <span data-translation={tooltipText.key}>
      <HoverImageInfo infoText={tooltipText} pictureText={pictureText} imageUrl={imageUrl} />
    </span>
  </SC.HeaderContainer>
);

export default SectionHeader;
